import { createContext, useContext } from 'react';
import { UiState } from './screens';
import { ILendingSession } from './types';

/** What every screen needs from the journey: the frame (stepper, close), the session and how to move on. */
export interface Journey {
  steps: string[];
  current: number;
  session: ILendingSession;
  ui: UiState & { paymentReference?: string };
  updateUi: (change: Partial<UiState & { paymentReference?: string }>) => void;
  /** Put a session a write returned into the cache. */
  setSession: (session: ILendingSession) => void;
  /** Fetch the session again (after writes that return something else, such as the offer). */
  refresh: () => void;
  close: () => void;
}

export const JourneyContext = createContext<Journey | null>(null);

export const useJourney = () => {
  const journey = useContext(JourneyContext);
  if (!journey) {
    throw new Error('useJourney must be used inside the lending journey');
  }
  return journey;
};
